import {
    Component, OnInit, SimpleChanges, Input, ChangeDetectorRef, OnChanges,
    OnDestroy, Output, EventEmitter, AfterContentChecked,
} from '@angular/core';
import {
    UntypedFormGroup,
    UntypedFormControl, UntypedFormArray, AbstractControl, UntypedFormBuilder, Validators
} from '@angular/forms';
import {
  //   TogetherAuctionDIPApplicantDetailsLegalBodyRoleAddresses,
  // TogetherAuctionDIPEquifaxAddress,
  TogetherBaseAddress,
} from './../models/api.models';
import { NodeAPIEntityService } from './../services/node.entity.service';
import { TogetherDIPState } from './../models/app.models';
import {
    TogetherAuctionDIPEntityType,
    TogetherAuctionDIPEntityOperation,
} from './../models/enums';
import * as _ from 'lodash-es';
import moment from 'moment';
// import { emit } from 'cluster';

/**
 *
 * @export
 * @class TogetherAuctionDIPApplicantMovedInComponent
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
    selector: 'together-auction-dip-applicant-moved-in-address',
    templateUrl: './dip.applicant.moved-in-address.component.component.html',
    standalone: false
})
export class TogetherAuctionDIPApplicantMovedInComponent implements OnInit, OnDestroy {

    @Input('children') public children: UntypedFormArray;
    @Input() iterator: number = 0;
    @Input() address: TogetherBaseAddress = new TogetherBaseAddress();
    @Input() incomingApplicantSequence: number = 0;
    @Input() hasLived3yearSelected: boolean;
    @Input() has_multiple_addresses: boolean = false;
    @Input() haslived3year: boolean = true;
    @Input() hasPostCodeNotEntered: boolean;
    @Input() incoming_case_id: string;
    @Input() changedYear: number;

    @Output() form_out: EventEmitter<object> = new EventEmitter<object>();
    @Output() loookUpformOut: EventEmitter<object> = new EventEmitter<object>();
    @Output() outgoing_haslived3year: EventEmitter<object> = new EventEmitter<object>();

    _haslived3year: boolean = true;

    tad_applicant_address: UntypedFormGroup = this.fb.group({});
    tad_moved_in_date_month: UntypedFormControl = new UntypedFormControl(null, [
        Validators.min(1),
        Validators.max(12),
        Validators.minLength(1),
        Validators.maxLength(2),
    ]);
    tad_moved_in_date_year: UntypedFormControl = new UntypedFormControl(null, [

    ]);

    tad_lived_three_year: UntypedFormControl = new UntypedFormControl(null, [
        this.customRequired(),
    ]);

    tad_moved_in_date: UntypedFormControl = new UntypedFormControl(null, []);

    searched: UntypedFormControl = new UntypedFormControl(null, []);

    addresslookup: UntypedFormGroup = this.fb.group({});

    tad_applicant_moved_in_form: UntypedFormGroup;

    _currentState: number = TogetherDIPState.New;

    /**
     *
     *
     * @readonly
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    get address_id() {
        if (!_.isNil(this.address))
            return this.address['Id'];
    }

    get index() {
        return _.toInteger(this.incomingApplicantSequence.toString() + this.iterator.toString());
    }


    /**
     *
     *
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    _handleForm() {
        this.tad_applicant_moved_in_form = this.fb.group({
            id: [this.address_id],
            iterator: [this.iterator],
            searched: this.searched,
            tad_applicant_address: this.tad_applicant_address,
            tad_moved_in_date_month: this.tad_moved_in_date_month,
            tad_moved_in_date_year: this.tad_moved_in_date_year,
            tad_lived_three_year: this.tad_lived_three_year,
            addresslookup: this.addresslookup,
        }, {
            validator: this.validateAddress('searched',
                'tad_applicant_address', 'postcode')
        });

        this.tad_applicant_moved_in_form.get('tad_lived_three_year').valueChanges.subscribe(
            (val: string) => {
                if (val === 'false') {
                    this.tad_applicant_moved_in_form.
                        get('tad_moved_in_date_month').setValidators([Validators.required,
                        Validators.min(1), Validators.max(12), Validators.minLength(1),
                        Validators.maxLength(2)]);
                    this.tad_applicant_moved_in_form.
                        get('tad_moved_in_date_year').setValidators([Validators.required,
                        Validators.max(new Date().getFullYear()),
                        Validators.min(1900), Validators.minLength(4),
                        Validators.maxLength(4)]);
                } else {
                    this.tad_applicant_moved_in_form.
                        get('tad_moved_in_date_year').clearValidators();
                    this.tad_applicant_moved_in_form.
                        get('tad_moved_in_date_month').clearValidators();
                }
            });
    }

    /**
     *
     *
     * @returns
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    validateAddress(controlName: string, addressControl: string, postcode: string) {
        var self = this
        return (group: UntypedFormGroup): { [key: string]: any } => {
            const control = group.controls[controlName] as UntypedFormControl;
            const address = group.controls[addressControl] as UntypedFormGroup;
            const postcodeControl = address.get(postcode) as UntypedFormControl;
            const monthCtrl = group.controls['tad_moved_in_date_month'] as UntypedFormControl;
            const yearCtrl = group.controls['tad_moved_in_date_year'] as UntypedFormControl;

            const monthValue = monthCtrl.value;
            const yearValue = yearCtrl.value;

            const errors = {};
            const dateY = yearValue + ' ' + monthValue + ' ' + 1;
            const isDateValid = moment(dateY, 'YYYY MM DD');
            const future = moment().add({ day: 1 });

            const eachValid = [_.isNil(monthValue) === false, _.isNil(yearValue) === false];
            const valuesUpdated = _.includes(eachValid, true);
            const allValuesSet = eachValid.every(p => p === true);

            if (control.touched && control.value === false) {
                errors['addressrequired'] = true;
            }
            if (_.isEmpty(address.controls)) {
                errors['addressrequired'] = true;
            }
            if (!_.isNil(postcodeControl) &&
                postcodeControl.touched && postcodeControl.hasError('required')) {
                errors['postcodeRequired'] = true;
            }

            if (monthCtrl.valid && yearCtrl.valid) {
                if (isDateValid.isValid && isDateValid.isAfter(future, 'day') && allValuesSet) {
                    errors['dateInFuture'] = true;
                }
            }
            if (_.isEmpty(errors)) {
                return null;
            }
            return errors;
        };
    }

    /**
     *
     *
     * @param {FormGroup} form
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    _handleIncomingForm(form: UntypedFormGroup) {
        const childgroup = this.children.controls[this.iterator] as UntypedFormGroup;
        childgroup.setControl('tad_applicant_address', form);
        this._handleForm();
        this.form_out.emit({
            hasYearChanges: true,
            iterator: this.iterator,
            address_id: this.address_id,
            form: this.children.controls[this.iterator],
        });
    }

    /**
     *
     *
     * @returns
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    customRequired() {
        // tslint:disable-next-line:no-var-self
        const self = this;
        return (input: UntypedFormControl): { [key: string]: any } => {
            return (self.iterator === 0 && _.isNil(input.value) && self._currentState !== 4) ?
                {
                    required: true,
                } : null;
        };
    }

    /**
     *
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    _handleState() {
        const address_id = this.address['Id'];
        if (_.isNil(address_id) || this.api.isNew(address_id)) {
            this._currentState = TogetherDIPState.New;
        } else if (this.api.isNew(address_id) === false) {
            this._currentState = TogetherDIPState.SavedWithAPI;
        } else {
            this._currentState = TogetherDIPState.Active;
        }
    }

    /**
     *
     *
     * @param {any} address
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    _handleIncomingAddress(address) {
        this._handleState();
        this.address = address.address;
        this.tad_applicant_moved_in_form.setControl('tad_applicant_address', address.form);
        const childgroup = this.children.controls[this.iterator] as UntypedFormGroup;
        childgroup.setControl('tad_applicant_address', address.form);
    }

    /**
     * Creates an instance of TogetherAuctionDIPApplicantMovedInComponent.
     * @param {FormBuilder} fb
     * @param {NodeAPIEntityService} api
     * @param {ChangeDetectorRef} ref
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    constructor(private fb: UntypedFormBuilder, private api: NodeAPIEntityService,
        private ref: ChangeDetectorRef) {
        this._handleForm();
    }

    /**
     *
     *
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    ngOnDestroy() {
        this.ref.detach();
        const controlArray = this.children.controls;
        const filter = controlArray.filter((x) => {
            const group = x as UntypedFormGroup;
            return group.get('iterator').value !== this.iterator;
        });
        this.children.controls = filter;
    }

    /**
     * Determines the state of this component; is it saved, new, error?
     *
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    _determineIncomingState() {
        const address_id = this.address['Id'];
        if (this.api.isNew(address_id) === false) {
            this._currentState = TogetherDIPState.SavedWithAPI;
        }
    }

    /**
     *
     *
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    onChangeYear(): void {
        const self = this;
        self.tad_applicant_moved_in_form.get('tad_moved_in_date_year').valueChanges.subscribe((val) => {
            if (!_.isNil(val) &&
                val.toString().length === 4 && self.tad_applicant_moved_in_form.
                    get('tad_moved_in_date_year').value !== self.changedYear) {
                self.changedYear = val;
                const month = self.tad_applicant_moved_in_form.get('tad_moved_in_date_month').value;
                const date = new Date(val, month - 1, 1);
                date.setHours(0, -date.getTimezoneOffset(), 0, 0);
                self.address['EffectiveFromDate'] = date.toISOString();
                self.tad_applicant_moved_in_form.get('tad_moved_in_date_year').setValue(val);
                this.children.controls[self.iterator].get('tad_moved_in_date_year').setValue(val);
                self.form_out.emit({
                    hasYearChanges: true,
                    iterator: this.iterator,
                    address_id: this.address_id,
                    form: this.children.controls[this.iterator],
                });
            }
        });
    }

    /**
     *
     *
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    _outputCreatedForm() {
        this.form_out.emit({
            hasYearChanges: false,
            iterator: this.iterator,
            address_id: this.address_id,
            form: this.children.controls[this.iterator],
        });
    }

    /**
     *
     *
     * @param {any} form
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    handleLookupForm(form) {

        this.loookUpformOut.emit({ form, iterator: this.iterator });
    }

    /**
     *
     *
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    _bindToForm() {
        this.changedYear = 0;
        const effectivedate = this.address['EffectiveFromDate'];
        const hasLivedThree = _.isNil(this.haslived3year) ? null : this.haslived3year;

        if (_.isNil(effectivedate) === false) {
            const date = new Date(effectivedate);
            this.tad_moved_in_date_month.setValue(date.getMonth() + 1);
            this.tad_moved_in_date_year.setValue(date.getFullYear());

            if (this._currentState === TogetherDIPState.SavedWithAPI
                && this.tad_lived_three_year.untouched) {
                this._haslived3year = false;
                this.tad_lived_three_year.setValue('false');
            } else {
                this.tad_lived_three_year.
                    setValue(_.isNil(this.haslived3year) ? null : _.toString(this.haslived3year));
            }
        } else {
            if (this._currentState === TogetherDIPState.SavedWithAPI &&
                this.tad_lived_three_year.untouched) {
                this._haslived3year = true;
                this.tad_lived_three_year.setValue('true');
            } else {
                this.tad_lived_three_year.
                    setValue(_.isNil(this.haslived3year) ? null : _.toString(this.haslived3year));
            }
        }
    }

    /**
      *
      * @param {string} control
      * @returns
      * @memberof TogetherAuctionDIPApplicantDetailComponent
      */
    setDynamicClasses(control: string) {
        return {
            'is-invalid form-control-danger': this.tad_applicant_moved_in_form.get(control).touched
                && this.tad_applicant_moved_in_form.get(control).invalid,
            'is-valid form-control-success': this.tad_applicant_moved_in_form.get(control).touched
                && this.tad_applicant_moved_in_form.get(control).valid,
        };
    }

    /**
     *
     * @param {string} control
     * @returns
     * @memberof TogetherAuctionDIPApplicantDetailComponent
     */
    setDynamicClassesForFormgroup(control: string) {
        return {
            'is-invalid': this.tad_applicant_moved_in_form.get(control).touched
                && this.tad_applicant_moved_in_form.get(control).invalid,
            'is-valid': this.tad_applicant_moved_in_form.get(control).touched
                && this.tad_applicant_moved_in_form.get(control).valid,
        };
    }

    /**
     *
     *
     * @param {boolean} value
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    onChange(value: boolean) {
        this._haslived3year = value;
        this.hasLived3yearSelected = false;
        this.changedYear = 0;
        this.tad_lived_three_year.
            setValue(_.isNil(this._haslived3year) ? null : _.toString(this._haslived3year));
        this.tad_lived_three_year.markAsTouched({ onlySelf: true });
        this.outgoing_haslived3year.emit({
            changedYear: this.changedYear,
            haslived3year: this._haslived3year,
            form: this.tad_applicant_moved_in_form,
        });
        if (value === true) {
            this.tad_applicant_moved_in_form.controls['tad_moved_in_date_month'].setValue(null);
            this.tad_applicant_moved_in_form.controls['tad_moved_in_date_year'].setValue(null);
            this._outputCreatedForm();
        }
    }

    /**
     *
     *
     * @memberof TogetherAuctionDIPApplicantMovedInComponent
     */
    ngOnInit() {
        // Determine whether we're new or not.
        this._handleForm();
        this.children.controls.push(this.tad_applicant_moved_in_form);
        this._determineIncomingState();
        this.onChangeYear();
        this._handleState();
        this._bindToForm();
    }
}
